import script from "./cat24AddRow.vue?vue&type=script&setup=true&lang=js"
export * from "./cat24AddRow.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__